import {
  AgentEffectCommands,
  AgentEffectDescription,
  FactionType,
} from "~/business";
import { ModalNames } from "~/jsx/context/ModalNames";
import { Colors, FontSize, Spacing } from "~/jsx/theme";
import {
  XAgentEffect,
  XCardFactionName,
  XCrossedSwordsSvg,
  XTypography,
} from "../design";
import { XDesignModal } from "../design/XDesignModal";

const {
  draw,
  trashMe,
  chooseFactionChange,
  garnison,
  buySpaceWarp,
  drawIntrigue,
  stealIntrigue,
  water,
  cause,
  hasInfluenceLevel2,
  hasAlliance,
  trashCard,
  fremenBond,
  discardCard,
  mentat,
} = AgentEffectCommands;
const effectWidth = 24;

export const XHelpModal = () => {
  return (
    <XDesignModal name={ModalNames.help} title="Help">
      <XTypography style={{ marginBottom: "1em", fontSize: FontSize.px18 }}>
        Icons
      </XTypography>
      <div
        style={{ display: "flex", flexDirection: "column", gap: Spacing.px4 }}
      >
        <XEffectHelp description="gain 1 water resource" effect={water(1)} />
        <XEffectHelp description="draw a card from your deck" effect={draw} />
        <XEffectHelp
          description="discard a card from your hand"
          effect={discardCard}
        />
        <XEffectHelp
          description="draw an intrigue card"
          effect={drawIntrigue}
        />
        <XEffectHelp description="destroy this card" effect={trashMe} />
        <XEffectHelp
          description="destroy a card from your hand, your discard or a card you played this turn"
          effect={trashCard}
        />
        <XEffectHelp
          description="choose a faction and gain 1 level of influence with that faction"
          effect={chooseFactionChange(1)}
        />
        <XEffectHelp effect={garnison(1)}>
          add 1 troop in your garnison. These troops can be deployed to the
          current conflict if the card was played on a{" "}
          <XCrossedSwordsSvg width={18} style={{ verticalAlign: "middle" }} />{" "}
          slot
        </XEffectHelp>
        <XEffectHelp
          description="add a spacewarp card in your discard"
          effect={buySpaceWarp}
        />
        <XEffectHelp
          description="opponents with 4 or more intrigue cards must give 1 intrigue card to you at random"
          effect={stealIntrigue}
        />
        <XEffectHelp
          description="pay 1 water to gain 1 level of inluence in the faction of your choice"
          effect={cause(water(1)).effect(chooseFactionChange(1))}
        />
        <XEffectHelp
          description="if you are on level 2 or higher on the Fremen influence track, gain 1 water"
          effect={cause(hasInfluenceLevel2(FactionType.Fremen)).effect(
            water(1)
          )}
        />
        <XEffectHelp
          description="if you have the alliance victory point of the Emperor faction, gain 1 water"
          effect={cause(hasAlliance(FactionType.Emperor)).effect(water(1))}
        />
        <XEffectHelp effect={cause(fremenBond).effect(water(1))}>
          if you played (revealed or for a slot) a card from the Fremen faction{" "}
          (<XCardFactionName faction={FactionType.Fremen} />
          ), gain 1 water
        </XEffectHelp>
        <XEffectHelp effect={mentat}>
          Get the mentat meaple that you can play as a normal meaple. Only works
          if the mentat is still on its action slot.
        </XEffectHelp>
      </div>
    </XDesignModal>
  );
};

const XEffectHelp = ({
  description,
  effect,
  children,
}: {
  description?: string;
  effect: AgentEffectDescription;
  children?: React.ReactNode;
}) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <XAgentEffect
        effectDescription={effect}
        width={effectWidth}
        color={Colors.common.black}
        context="card"
      />
      <XTypography style={{ marginLeft: Spacing.px8 }}>
        : {description ?? children}
      </XTypography>
    </div>
  );
};
